<div
  class="filter-item"
  [ngClass]="{
    'filter-open': isFilterTypeOpen,
    'filter-select': filterExists(filter.fieldName)
  }"
  #filterType
  (click)="setDisplayDetailsFilter(filter)"
>
  <h5 class="item-name" translate [translateParams]="{ item: filter }">
    filter.item
  </h5>
  <img class="filter-selector" src="/assets/images/dropdown-icon.svg" />
  <div
    class="reset-filter"
    (click)="resetFilter(filter.fieldName, $event)"
    *ngIf="filterExists(filter.fieldName)"
  >
    <img src="/assets/images/definitions/reset-input.svg" />
    <div class="circle-of-filter">{{ filterNumber(filter.fieldName) }}</div>
  </div>
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="filterType"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isFilterTypeOpen = false"
  [cdkConnectedOverlayOpen]="isFilterTypeOpen"
  cdkConnectedOverlayBackdropClass="backdrop-selection"
  [cdkConnectedOverlayPositions]="positonArea"
>
  <div [ngSwitch]="filter.fieldName">
    <div class="type-list-wrapper creator" *ngSwitchCase="'creator'">
      <ng-container *ngIf="creatorFilterOptions$() as names">
        <que-autocomplete-filter
          class="autocomplete-filter"
          [formControl]="valueControl"
          [autoCompleteList]="names"
          [selected]="selectedFilterSig$()?.creator"
        >
        </que-autocomplete-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'categoryId'">
      <ng-container *ngIf="categories$()?.length">
        <que-category-filter
          [categoriesList]="categories$()"
          [formControl]="valueControl"
        ></que-category-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'status'">
      <ng-container *ngIf="!isDisplayUser$()">
        <que-status-filter  [formControl]="valueControl"></que-status-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'statusToUser'">
      <ng-container *ngIf="isDisplayUser$()">
        <que-status-to-user-filter [formControl]="valueControl"></que-status-to-user-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'statusApproval'">
      <ng-container>
        <que-status-approval-filter [formControl]="valueControl"></que-status-approval-filter>
      </ng-container>
    </div>
    <div class="type-list-wrapper creator" *ngSwitchCase="'approverIds'">
      <ng-container *ngIf="reportApproverNames$() as names">
        <que-autocomplete-filter
          class="autocomplete-filter"
          [formControl]="valueControl"
          [autoCompleteList]="names"
          [selected]="selectedFilterSig$()?.approverIds"
        >
        </que-autocomplete-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'questionnaireNumber'">
      <ng-container>
        <que-number-filter [formControl]="valueControl"></que-number-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'formStatus'">
      <ng-container>
        <que-form-status-filter [formControl]="valueControl"></que-form-status-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'mlmExportStatus'">
      <ng-container>
        <que-mlm-export-status-filter [formControl]="valueControl"></que-mlm-export-status-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'payrollMonths'">
      <ng-container>
        <que-payroll-month-filter [formControl]="valueControl"></que-payroll-month-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'amount'">
      <ng-container>
        <que-amount-range-filter [formControl]="valueControl"></que-amount-range-filter>
      </ng-container>
    </div>
    <div *ngSwitchCase="'clientCharge'">
      <ng-container>
        <que-client-charge-filter [formControl]="valueControl"></que-client-charge-filter>
      </ng-container>
    </div>
    <div *ngSwitchDefault></div>
  </div>
  <div [ngSwitch]="filter.typeFilter">
    <div class="overlay-warp" *ngSwitchCase="enumFilterType.DATE">
      <div
        class="item"
        [ngClass]="{
          active:
            selectedFilterSig$() &&
            selectedFilterSig$()![filter.fieldName]?.dateRangeType ==
              dateRange.key
        }"
        *ngFor="let dateRange of dateRangeFilter$ | async; let i = index"
        (click)="changeDateRange(dateRange, i, filter.fieldName)"
      >
        <p translate [translateParams]="{ itemInSelectDate: dateRange }">
          filter.itemInSelectDate
        </p>
        <div *ngIf="dateRange.key == customDateRangeType" #dateRangeToSelect>
          <img class="scale-img" src="/assets/images/date-range-icon.svg" />
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="dateRangeToSelect"
            [cdkConnectedOverlayHasBackdrop]="true"
            (backdropClick)="selectedRangeIsOpened = false"
            [cdkConnectedOverlayOpen]="selectedRangeIsOpened"
            cdkConnectedOverlayBackdropClass="backdrop-selection"
            [cdkConnectedOverlayPositions]="positonAreaForSelectedRange"
          >
            <que-dual-calendar-range-picker
              [customDateFrom]="
                selectedFilterSig$()[filter.fieldName]?.customDateFromNTZ
              "
              [customDateTo]="
                selectedFilterSig$()[filter.fieldName]?.customDateToNTZ
              "
              (rangeChanged)="dateRangePicked($event, filter.fieldName)"
            ></que-dual-calendar-range-picker>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
